// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-password {
   display: flex;
   position: relative;
   /*width: fit-content;*/
   width: 100%;
   background-color: var(--frame-bg);
   justify-content: center;
   align-items: center;
   border-radius: var(--border-radius);
}

.ecl-password input::-ms-reveal {
   /*Hides Edge/IE default show password button*/
   display: none;
}


.ecl-password .ecl-password-button {
   background-color: unset;
   position: absolute;
   left: calc(100% - 35px);
   width: 30px;
   height: 30px;
   padding: 0;
   margin: 0;
}

.label-input-div .ecl-password .ecl-password-button {
   background-color: unset;
   position: absolute;
   left: calc(100% - 35px);
   width: 30px;
   height: 30px;
   padding: 0;
   margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLInputs/ECLPassword/ECLPassword.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,kBAAkB;GAClB,sBAAsB;GACtB,WAAW;GACX,iCAAiC;GACjC,uBAAuB;GACvB,mBAAmB;GACnB,mCAAmC;AACtC;;AAEA;GACG,6CAA6C;GAC7C,aAAa;AAChB;;;AAGA;GACG,uBAAuB;GACvB,kBAAkB;GAClB,uBAAuB;GACvB,WAAW;GACX,YAAY;GACZ,UAAU;GACV,SAAS;AACZ;;AAEA;GACG,uBAAuB;GACvB,kBAAkB;GAClB,uBAAuB;GACvB,WAAW;GACX,YAAY;GACZ,UAAU;GACV,SAAS;AACZ","sourcesContent":[".ecl-password {\r\n   display: flex;\r\n   position: relative;\r\n   /*width: fit-content;*/\r\n   width: 100%;\r\n   background-color: var(--frame-bg);\r\n   justify-content: center;\r\n   align-items: center;\r\n   border-radius: var(--border-radius);\r\n}\r\n\r\n.ecl-password input::-ms-reveal {\r\n   /*Hides Edge/IE default show password button*/\r\n   display: none;\r\n}\r\n\r\n\r\n.ecl-password .ecl-password-button {\r\n   background-color: unset;\r\n   position: absolute;\r\n   left: calc(100% - 35px);\r\n   width: 30px;\r\n   height: 30px;\r\n   padding: 0;\r\n   margin: 0;\r\n}\r\n\r\n.label-input-div .ecl-password .ecl-password-button {\r\n   background-color: unset;\r\n   position: absolute;\r\n   left: calc(100% - 35px);\r\n   width: 30px;\r\n   height: 30px;\r\n   padding: 0;\r\n   margin: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
